export default __webpack_public_path__ + "static/media/1834.2ce2cbc0.png";